module.exports = __webpack_public_path__ + "img/grand-palm-room-2.cd5c142b.jpg";